import type { ApiContext } from "@/api/types";
import type {
  CosignaturePermissionMetadata,
  CosignatureSupervisorsResponse,
  OptionalPermission,
  RequiredPermission,
  UserPermissions,
} from "@/core/types";
import { httpAuth2 } from "@/api/auth";

export type UpdateUserPermissionsPayload = {
  co_sign:
    | OptionalPermission
    | (RequiredPermission &
        Pick<
          CosignaturePermissionMetadata,
          "assigned_supervisor_id" | "requirement_reason" | "requirement_reason_details"
        >);
};

export const permissionsRequestsTyped = {
  get_cosign_supervisors: function ({ context }: { context?: ApiContext } = {}) {
    return httpAuth2
      .get("/v1/permissions/cosign_supervisors", {
        context: { preventAllErrorToast: true, showLoader: false, ...context },
      })
      .json<CosignatureSupervisorsResponse>();
  },

  get_user_permissions: function ({ context, userId }: { context?: ApiContext; userId: string }) {
    return httpAuth2
      .get(`/v1/user/${userId}/permissions`, {
        context: { preventAllErrorToast: true, showLoader: false, ...context },
      })
      .json<UserPermissions>();
  },

  update_user_permissions: function ({
    context,
    json,
    userId,
  }: {
    context?: ApiContext;
    json: UpdateUserPermissionsPayload;
    userId: string;
  }) {
    return httpAuth2
      .post(`/v1/user/${userId}/permissions`, {
        context: { preventAllErrorToast: true, showLoader: false, ...context },
        json,
      })
      .json<UserPermissions>();
  },
};
